export const base64Encode = (str = "") => {
  return btoa(str);
};

export const capitalize = (str = "") => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const generate = (str: string, count: number, delimiter = "") => {
  return Array(count).fill(str).join(delimiter);
};

export const clean = (str = "") => {
  let formattedStr = str.toLowerCase().replace(/([.,!?:-_\"\'])/g, "");

  formattedStr = formattedStr.replace(/zero/g, "0");
  formattedStr = formattedStr.replace(/one/g, "1");
  formattedStr = formattedStr.replace(/two/g, "2");
  formattedStr = formattedStr.replace(/three/g, "3");
  formattedStr = formattedStr.replace(/four/g, "4");
  formattedStr = formattedStr.replace(/five/g, "5");
  formattedStr = formattedStr.replace(/six/g, "6");
  formattedStr = formattedStr.replace(/seven/g, "7");
  formattedStr = formattedStr.replace(/eight/g, "8");
  formattedStr = formattedStr.replace(/nine/g, "9");

  return formattedStr;
};

export const splitSentences = (str = "") => {
  const sentenceEndings = /([.!?](?:\s|"|'|"|'))/g;
  const markedParagraph = str.replace(sentenceEndings, "$1|");
  const sentences = markedParagraph
    .split("|")
    .map((sentence) => sentence.trim())
    .filter((sentence) => sentence.length > 0);

  return sentences;
};

export const formatTime = (time: number) => {
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
};

export const slugify = (name: string) => {
  return name.toLowerCase().replace(/\s+/g, "_");
};

/**
 * Safely converts a value to a renderable string.
 * - Strings pass through as-is
 * - Objects/arrays are JSON.stringify'd
 * - null/undefined return the fallback
 *
 * This prevents React error #31 ("Objects are not valid as a React child")
 * when API data contains unexpected object values in fields typed as strings.
 */
export const safeString = (value: unknown, fallback: string | null = null): string | null => {
  if (typeof value === "string") return value;
  if (value === null || value === undefined) return fallback;
  if (typeof value === "number" || typeof value === "boolean") return String(value);
  try {
    return JSON.stringify(value);
  } catch {
    return fallback;
  }
};

// Format phone number to 1 (XXX) XXX-XXXX or (XXX)XXX-XXXX
export const formatPhoneNumber = (phoneNumber: string) => {
  // Remove all non-digit characters
  const cleaned = phoneNumber.replace(/\D/g, "");

  // Handle 11-digit US numbers (with country code)
  const match11 = cleaned.match(/^1(\d{3})(\d{3})(\d{4})$/);
  if (match11) {
    return `1 (${match11[1]}) ${match11[2]}-${match11[3]}`;
  }

  // Handle 10-digit US numbers (without country code)
  const match10 = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match10) {
    return `(${match10[1]})${match10[2]}-${match10[3]}`;
  }

  // Return the original number if it doesn't match the expected format
  return phoneNumber;
};
